<template>
  <span
    class="dropdown text-center"
    v-if="showPsychologyOrganizationLink && psychologyOrganizationLink"
  >
    <a
      class="dropdown-toggle"
      href="#"
      role="button"
      id="exClickable"
      data-bs-toggle="dropdown"
      data-bs-auto-close="outside"
      aria-expanded="false"
    >
      <svg
        width="18px"
        height="18px"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        class="bi bi-file-person text-secondary me-1"
        viewBox="0 0 16 16"
      >
        <path
          d="M12 1a1 1 0 0 1 1 1v10.755S12 11 8 11s-5 1.755-5 1.755V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"
        ></path>
        <path d="M8 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"></path>
      </svg>
    </a>

    <div
      class="dropdown-menu p-4"
      style="width: 350px"
      aria-labelledby="dropdownMenuLink"
      ref="profileMenu"
    >
      <div class="text-end clearfix p-0 m-0">
        <button
          type="button"
          class="modal-header btn-close mt-0 mb-2 pointer float-end"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="closeButtonClick"
        ></button>
      </div>
      <p class="small justified">
        شما می توانید از لینک زیر به منظور مشاهده پروفایل درمانگر در سایت رسمی
        سازمان نظام روانشناسی و مشاوره کشور استفاده نمایید.
      </p>
      <a
        :href="psychologyOrganizationLink"
        target="_blank"
        class="btn w-100 btn-sm rounded btn-blueSite"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-person-bounding-box ms-2"
          viewBox="0 0 16 16"
        >
          <path
            d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5z"
          ></path>
          <path
            d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
          ></path>
        </svg>
        نمایش پروفایل درمانگر
      </a>
    </div>
  </span>
</template>
<script>
export default {
  props: {
    showPsychologyOrganizationLink: {
      type: Boolean,
      required: false,
      default: true,
    },
    psychologyOrganizationLink: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeButtonClick() {
      if (this.$refs.profileMenu) {
        this.$refs.profileMenu.classList.toggle('show');
      }
    },
  },
};
</script>
